import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Services from './components/Services';
import Contact from './components/Contact';
import About from './components/About';
import Footer from './components/Footer';
import FAQ from './components/FAQ';
import Reservation from './components/Reservation';
import Policy from './components/Policy';
import ScrollToTop from './components/ScrollToTop';
import PageLoader from './components/PageLoader';
import CookieBanner from './components/CookieBanner';
import NotFound from './components/NotFound';
import Seo from './components/Seo';
import TransportSeoPage from './components/TransportSeoPage';
import './styles/App.css';
import './styles/ModernPages.css';

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="App">
        <Seo />
        <Navbar />
        <main>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/reservation" element={<Reservation />} />
              <Route path="/about" element={<About />} />
              <Route path="/policy" element={<Policy />} />
              <Route path="/transport-medico-sanitaire-bruxelles" element={<TransportSeoPage />} />
              <Route path="/transport-pmr-bruxelles" element={<TransportSeoPage />} />
              <Route path="/transport-dialyse-bruxelles" element={<TransportSeoPage />} />
              <Route path="/transport-hopital-bruxelles" element={<TransportSeoPage />} />
              <Route path="/transport-seniors-bruxelles" element={<TransportSeoPage />} />
              <Route path="/remboursement-transport-medical" element={<TransportSeoPage />} />
              <Route path="/transport-medical-anderlecht" element={<TransportSeoPage />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>
        <ScrollToTop />
        <Footer />
        <CookieBanner />
      </div>
    </Router>
  );
}

export default App;
